import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Trans, useTranslation } from 'react-i18next';
import { theme } from 'antd';

import { useStores } from '@/hooks/use-stores';
import { useMeasurement } from '@/hooks/useMeasurement';
import { getPredefinedPowerScale } from '@/constants/getPredefinedPowerScale';
import Super from '@/comp/Super';
import MapKPIBox from './MapKPIBox';
import mapKPIConfig from './MapKPIConfig';
import { useSpecificPowerKPI } from './MapKPI.utils';

const { useToken } = theme;
const MapKPI = observer(() => {
  const { stationStore } = useStores();
  const { t } = useTranslation();
  const { tvalue, tunit } = useMeasurement();
  const specificPower = useSpecificPowerKPI();
  const { token } = useToken();

  const kpis = mapKPIConfig(stationStore, t, tvalue, tunit, token);

  const KPIBoxes = kpis.map(kpi => <MapKPIBox key={kpi.key} kpi={kpi} stationStore={stationStore} />);

  return (
    <Container>
      {stationStore.isSidebarCollapsed && (
        <MapKPIBox
          kpi={{
            key: 'specific_power',
            title: t('SPECIFIC POWER'),
            value: tvalue(specificPower, 'kW/(m^3/min)'),
            unit: (
              <Trans i18nKey={tunit('kW/(m3/min)')}>
                <Super />
              </Trans>
            ),
            scale: getPredefinedPowerScale(stationStore, tvalue, token),
            tooltip: t('Value may depend on multiple sensors.'),
          }}
          stationStore={stationStore}
        />
      )}
      {KPIBoxes}
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  justify-content: space-between;

  .tier-wrapper {
    display: flex;
  }
`;

export default MapKPI;
